import { useChargeWaiverVM } from "presentation/hook/ChargeWaiver/useChargeWaiverVM";
import { useChargeWaiverTracked } from "presentation/store/ChargeWaiver/ChargeWaiverProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import ChargeWaiverTitleBar from "./ChargeWaiverTitleBar";
import ChargeWaiverSearchPanel from "./LeftPanel/ChargeWaiverSearchPanel";
import ChargeWaiverRightPanel from "./RightPanel/ChargeWaiverRightPanel";


const ChargeWaiverMaintenance: React.FC = () => {
    const [chargeWaiverState] = useChargeWaiverTracked();
    const chargeWaiverVM = useChargeWaiverVM();
    const { isShowCriteriaPanel } = chargeWaiverState;
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            chargeWaiverVM.setIsSearchLoading(true);
            await Promise.allSettled([
                chargeWaiverVM.loadDropdownOption(),
            ]);
        }

        initialScreen().then(async () => {
            chargeWaiverVM.setIsSearchLoading(false);
            setIsLoading(false);
        }).catch(error => {
            chargeWaiverVM.setIsSearchLoading(false);
            setIsLoading(false);
        }).finally(() => {
            setIsLoading(false);
        })

    }, [chargeWaiverVM])



    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowCriteriaPanel ? '' : ' im-hide-side-form-draggable'}`}>
            <ChargeWaiverTitleBar />
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowCriteriaPanel ? "25%" : "0%"}
                rightSectionWidth={isShowCriteriaPanel ? "75%" : "100%"}
                leftChildren={<ChargeWaiverSearchPanel />}
                rightChildren={<ChargeWaiverRightPanel />}
            />
        </div>
    </>
}

export default memo(ChargeWaiverMaintenance);